module.exports = __webpack_public_path__ + "img/mariage-vignette.ce7e231e.jpg";